import { render, staticRenderFns } from "./platform-modifiers.vue?vue&type=template&id=550038b3"
import script from "./platform-modifiers.vue?vue&type=script&lang=js"
export * from "./platform-modifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports